<template>
  <div class="tw-my-4 md:tw-my-8">
    <v-card class="mx-auto tw-py-2 md:tw-py-3" outlined>
      <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Home Option</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-justify-between tw-px-2 md:tw-px-8">
          <div class="tw-flex tw-flex-wrap tw-px-2 md:tw-px-8">
            <div class="tw-flex md:tw-block tw-justify-between tw-w-full md:tw-w-auto ">
              <p class="c-gray-text"><strong class="c-navy-text tw-uppercase">Home Option: </strong> {{ quote.home_option }} </p>
            </div>
          </div>
        </div>
      </v-card>
      <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
        <hr />
      </div>
      <v-card v-if="quote.building_value" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Benefit Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">BUILDING</h2>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">It provides coverage for your dwelling subject to the benefit limits.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.building_value | formatNum }} </h2>
          </div>
        </div>
      </v-card>
      <v-card v-if="quote.house_items_value" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Benefit Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">HOUSE ITEMS</h2>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">It provides coverage for your house items within your dwelling subject to the benefit limits.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.house_items_value | formatNum }} </h2>
          </div>
        </div>
      </v-card>
      <v-card v-if="quote.portable_items_value" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Benefit Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">PORTABLE ITEMS</h2>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">It provides coverage for your portable items subject to the benefit limits.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.portable_items_value | formatNum }} </h2>
          </div>
        </div>
      </v-card>
      <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Benefit Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">Occupier’s and Owner’s liability </h2>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">It provides coverage for Occupier’s and Owner’s liability subject to the benefit limits.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ 1000000 | formatNum }} </h2>
          </div>
        </div>
      </v-card>
      <div class="tw-px-3 md:tw-px-10 tw-py-3 tw-flex tw-flex-wrap tw-justify-between">
        <h2 class="c-blue-text tw-font-bold tw-text-xl md:tw-text-2xl">Premium Payable: Ksh {{ quote.premium | formatNum }}</h2>
        <v-btn color="primary" @click="startOver">Generate New Quote</v-btn>
        <v-btn color="secondary" @click="buyDP">Buy Now</v-btn>
        <EmailDPQuotation />
      </div>
    </v-card>
  </div>
</template>

<script>

import EmailDPQuotation from '@/components/rfq/dp/EmailDPQuotation';
import helpers from '@/utils/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'DPQuoteSummary',
  components: {
    EmailDPQuotation,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    quote() {
      return this.$store.getters['rfq/getDPQuoteResponse'];
    },
  },
  methods: {
    buyDP() {
      this.$store.commit('rfq/clearDPQuotation');
      if (this.isAuthenticated) {
        this.$router.push({ name: 'BuyCover', query: { q: this.quote.id, b: 'dp' } });
      } else {
        this.$router.push({ name: 'SignIn', query: { q: this.quote.id, b: 'dp' } });
      }
    },
    startOver() {
      this.$store.commit('rfq/clearDPQuotation');
      this.$root.$emit('nav-back-to', { currentTab: 'StartDP' });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num || 10000);
    },
  },
};
</script>
